// extracted by mini-css-extract-plugin
export var card = "_8h-0";
export var expandedCard = "_8h-2";
export var paginated = "_8h-1";